import { Button, FileInput, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconCheck, IconFileUpload } from '@tabler/icons-react';
import { useRequest } from 'ahooks';
import { zodResolver } from 'mantine-form-zod-resolver';
import { z } from 'zod';

import { useUploadThing } from '../../../../../services/upload';

interface AddDocumentSubmitFormValues {
  utFileKey: string;
  fileName: string;
}

interface UploadQuoteProps {
  projectId: string;
  onSubmit: (values: AddDocumentSubmitFormValues) => Promise<void>;
}

export function UploadQuoteForm({ onSubmit }: UploadQuoteProps) {
  const { startUpload } = useUploadThing('fileUploader');

  const form = useForm({
    initialValues: {
      file: null,
    },
    validate: zodResolver(
      z.object({
        file: z.instanceof(File, {
          message: 'Fichier requis',
        }),
      }),
    ),
    transformValues: values => ({
      ...values,
      file: values.file,
    }),
  });

  const { run: handleSubmit, loading: isSubmitting } = useRequest(
    async values => {
      const uploadResponse = await startUpload([values.file]);
      if (!uploadResponse) return;

      const [fileResponse] = uploadResponse;
      await onSubmit({
        utFileKey: fileResponse.key,
        fileName: values.file.name,
      });
    },
    { manual: true },
  );

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack>
        <FileInput
          required
          label="Fichier"
          placeholder="Cliquez pour sélectionner un fichier"
          accept="application/pdf,application/msword"
          leftSection={<IconFileUpload size={14} />}
          {...form.getInputProps('file')}
        />
        <Button
          type="submit"
          loading={isSubmitting}
          leftSection={<IconCheck size={16} />}
        >
          Valider
        </Button>
      </Stack>
    </form>
  );
}
